import ppv1 from "Assets/Images/ppv-1.jpeg";
import ppv2 from "Assets/Images/ppv-2.jpeg";
import ppv3 from "Assets/Images/ppv-3.jpeg";
import ppv4 from "Assets/Images/ppv-4.jpeg";
import ppv5 from "Assets/Images/ppv-5.jpeg";
import ppv6 from "Assets/Images/ppv-6.jpeg";
import ppvimage from "Assets/Images/ppv-what.jpg";
import ContentNavbar from "components/ContentNavbar";
import WelcomePageSidebar from "pages/welcome/WelcomePageSidebar";
import { contentNavData } from "constant/ContentNavBarData";
import Footer from "components/Footer";
import { useEffect } from "react";
import { RouteName } from "constant/routeNames";
import { Helmet } from "react-helmet-async";
import PPVHero from "./landing/PPVHero";
import SectionIntro from "./landing/SectionIntro";
import ParallaxBand from "./landing/ParallaxBand";
import BenefitCards from "./landing/BenefitCards";
import ProcessSteps from "./landing/ProcessSteps";
import FeatureRow from "./landing/FeatureRow";
import ClosingCTA from "./landing/ClosingCTA";

const PPVLanding = ({ isActive, handleClick, setIsActive }: any) => {
  const FE_URL = process.env.REACT_APP_FRONTEND_URL;
  const exploreLink = RouteName.PayPerView.replace("*", "");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Watch Exclusive Pay Per View content with AYOZAT.com</title>
        <meta
          name="description"
          content="Join AYOZAT.com for PPV streams featuring exclusive content, interactive events, and special shows. Subscribe now for the ultimate fan experience."
        />
        <link rel="canonical" href={`${FE_URL}/ppv/influencer `} />
        <meta
          property="og:title"
          content="Watch Exclusive Pay Per View content with AYOZAT.com"
        />
        <meta
          property="og:description"
          content="Join AYOZAT.com for PPV streams featuring exclusive content, interactive events, and special shows. Subscribe now for the ultimate fan experience."
        />
        <meta property="og:image" content="https://ayozat.co.uk/logo192.png" />
        <meta property="og:type" content="website" />
        <meta name="og:url" content={`${FE_URL}/ppv/influencer `} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Watch Exclusive Pay Per View content with AYOZAT.com"
        />
        <meta
          name="twitter:description"
          content="Join AYOZAT.com for PPV streams featuring exclusive content, interactive events, and special shows. Subscribe now for the ultimate fan experience."
        />
        <meta name="twitter:image" content="https://ayozat.co.uk/logo192.png" />
        <meta name="twitter:site" content="AYOZAT STREAM" />
        <meta name="twitter:url" content={`${FE_URL}/ppv/influencer `} />
      </Helmet>

      <ContentNavbar
        handleClick={handleClick}
        isActive={isActive}
        setIsActive={setIsActive}
      />
      <WelcomePageSidebar
        isActive={isActive}
        navData={contentNavData}
        setIsActive={setIsActive}
      />
      <div
        className={
          isActive
            ? "md:pl-[100px] pl-[80px] duration-500 p-2 mt-2 ml-3 max-sm:pl-0 max-sm:ml-2 "
            : "pl-0 duration-500 p-2 mt-2 ml-8 max-sm:pl-0 max-sm:ml-2 "
        }
      >
        <PPVHero link={exploreLink} image={ppv1} />

        <SectionIntro
          eyebrow="Why AYOZAT PPV"
          title="Revolutionize Your Income — Tap Into Fresh Revenue Sources"
          description="In today's digital landscape, content creators and musicians need innovative ways to generate revenue. Pay-Per-View (PPV) videos offer an additional source of income while giving creators full control over their content."
        />

        <ParallaxBand src={ppvimage} alt="What is Pay-Per-View" />

        <SectionIntro
          title="What Is Pay-Per-View?"
          description="Pay-Per-View (PPV) allows viewers to access premium live content for a fee. With AYOZAT, you can earn money every time you hold a PPV event. This flexible model caters to diverse content types, including tutorials, workshops, events, and exclusive interviews."
        />

        <BenefitCards />

        <SectionIntro title="How Does Pay-Per-View Work?" />
        <ProcessSteps />

        <SectionIntro eyebrow="Built For Creators" title="Creator and Influencer Benefits for PPV Events" />

        <FeatureRow
          mainText="Guaranteed Earnings"
          subText="Ensure a reliable income stream from your live events, regardless of audience size."
          image={ppv1}
        />

        <FeatureRow
          mainText="Creative Autonomy"
          subText="Retain full ownership and control over your content, minimizing dependency on advertising through Pay-Per-View options."
          image={ppv2}
          reverse
        />

        <FeatureRow
          mainText="Audience Analytics"
          subText="Access detailed insights into your viewers, including demographics and preferences."
          image={ppv3}
        />

        <FeatureRow
          mainText="Global Reach"
          subText="Expand your audience and maximize revenue by reaching viewers worldwide."
          image={ppv4}
          reverse
        />

        <FeatureRow
          mainText="Live Show Monetization"
          subText="Run live shows as Pay-Per-View events, reaching both your audience and AYOZAT's extensive user base. Benefit from instant monetization with a majority revenue share split."
          image={ppv5}
        />

        <FeatureRow
          mainText="Diverse Content Opportunities"
          subText="PPV offers influencers, content creators, musicians, sports bodies, and more the chance to secure a majority share of the revenue from new sources."
          image={ppv6}
          reverse
        />

        <ClosingCTA link={exploreLink} />
      </div>
      <Footer />
    </>
  );
};

export default PPVLanding;
